// import messagesNotifyHelper from '@/helpers/messages-notify-helper';

export default {
  namespaced: true,
  state: {
    tabs: [],
    tabIndex: 0,
    tabCount: 0
  },
  getters: {},
  mutations: {
    CLOSE_TAB(state, val) {
      const index = state.tabs.findIndex(item => item.index == val.index);
      if (index >= 0) {
        state.tabs.splice(index, 1);
      }
      state.tabCount = state.tabs.length;
      // for (let i = 0; i < state.tabs.length; i += 1) {
      //   if (state.tabs[i].index === val.index) {
      //     state.tabs.splice(i, 1);
      //   }
      // }
      // state.tabIndex = state.tabs.length - 1;
    },
    NEW_TAB(state, val) {
      // console.log('NEW_TAB');
      state.tabCount++;
      val.index = state.tabCount;
      state.tabs.push(val);
      state.tabIndex = state.tabs.length - 1;
      // console.log(state.tabIndex);
      // if (state.tabs.length <= 6) {
      //   val.index = state.tabs.length > 0 ? state.tabs[state.tabs.length - 1].index + 1 : 0;
      //   state.tabs.push(val);
      // } else {
      //   messagesNotifyHelper.warningNotify('Abas', 'Atingiu numero máximo de abas');
      // }
    },
    UPDATE_TAB_NAME(state, val) {
      if (!val) {
        return;
      }
      if (val.title.length > 30) {
        val.title = `${val.title.substring(0, 27)}...`
      }
      const index = state.tabs.findIndex(item => item.index == val.index);
      if (index >= 0) {
        state.tabs[index].title = val.title;
      }
    },
    UPDATE_TAB_INDEX(state) {
      // state.tabIndex = state.tabs.length > 0 ? state.tabs[state.tabs.length - 1].index : 0;
      state.tabIndex = state.tabs.length - 1;
      // console.log('UPDATE_TAB_INDEX', state.tabIndex);
    },
    UPDATE_FORM_TAB(state, val) {
      if (val.form) {
        const index = state.tabs.findIndex(item => item.index == val.index);
        if (index >= 0) {
          state.tabs[index].form = Object.create(val.form);
        }
      }
    },
    CLEAR_TABS(state) {
      state.tabs = [];
      state.tabIndex = 0;
      state.tabCount = 0;
    }
  },
  actions: {
    closeTab({ commit }, payload) {
      commit('CLOSE_TAB', payload);
    },
    newTab({ commit }, payload) {
      commit('NEW_TAB', payload);
    },
    updateTabName({ commit }, payload) {
      commit('UPDATE_TAB_NAME', payload);
    },
    updateTabIndex({ commit }, payload) {
      commit('UPDATE_TAB_INDEX', payload);
    },
    updateFormTab({ commit }, payload) {
      commit('UPDATE_FORM_TAB', payload);
    },
    clearTabs({ commit }, payload) {
      commit('CLEAR_TABS', payload);
    },
  },
}
